import axios from 'axios';
const instance = axios.create({ baseURL: 'https://capydemy.fly.dev' })
export default instance
